import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetErrorImageResData extends ApiGenericResponse {
    errorImage: string = "";

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.errorImage = response.data.Payload;
        }
    }
}
